import { compactNumber, relativeTime } from "../format";
import type { Status } from "../../shared/types";

function Stat({ label, value, tint }: { label: string; value: string; tint?: string }) {
  return (
    <div className="stat">
      <div className="stat-label">{label}</div>
      <div className="stat-value" style={tint ? { color: tint } : undefined}>
        {value}
      </div>
    </div>
  );
}

export function StatStrip({ status }: { status: Status | null }) {
  if (!status) {
    return (
      <div className="stats">
        {["Papers tracked", "Keywords", "Matches", "Recipients", "Queued email", "Awaiting text"].map((label) => (
          <Stat key={label} label={label} value="—" />
        ))}
      </div>
    );
  }

  const { counts, harvest } = status;
  const seeding = harvest.mode === "seeding";

  return (
    <div className="stats">
      <Stat label="Papers tracked" value={compactNumber(counts.papers)} />
      <Stat label="Keywords" value={compactNumber(counts.keywords)} />
      <Stat label="Matches" value={compactNumber(counts.matches)} tint="var(--accent)" />
      <Stat label="Recipients" value={compactNumber(counts.recipients)} />
      <Stat
        label="Queued email"
        value={compactNumber(counts.pendingNotifications)}
        tint={counts.pendingNotifications > 0 ? "var(--accent2)" : undefined}
      />
      <Stat
        label="Awaiting text"
        value={compactNumber(counts.awaitingText)}
        tint={counts.awaitingText > 0 ? "var(--accent2)" : undefined}
      />
      <Stat
        label={seeding ? "Seeding history" : "Last poll"}
        value={seeding ? (harvest.passActive ? "running" : "pending") : relativeTime(status.lastRun?.startedAt ?? null)}
        tint={seeding ? "var(--accent2)" : undefined}
      />
    </div>
  );
}
